// import { EquipmentList, SortingTypes } from 'ui/components';
import _ from 'lodash';
import {
	useState,
	useEffect,
	useContext,
	useCallback,
	useMemo,
	useRef,
} from 'react';
import { getEquipmentsByCategory } from 'application/repositories/equipmentRepository';
import {
	selection,
	facets,
	facetsChanged,
	categories,
} from 'application/adapters/store/slices/categorySlice';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { DictionaryContext } from 'application/adapters/context/Dictionary';
import cultureSlice, {
	currentCulture,
} from 'application/adapters/store/slices/cultureSlice';
import { LocaleContext } from 'application/adapters/context/LocaleContext';

import { SupportCenterView } from 'ui/components/3-organisms/SupportCenterView';

export const SupportCenterFeature: unknown = ({ accessToken }) => {
	const router = useRouter();
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const dictionary = useContext(DictionaryContext);

	const SupportCenterDictionary = {
		heading: dictionary.getValue(
			'SupportCenter.Heading',
			null,
			'Support Center',
		),
	};

	return (
		<SupportCenterView
			heading={SupportCenterDictionary.heading}
			isLoading={!isLoading}
		/>
	);
};
